export default "__VITE_ASSET__Dk4Qa$L9__"